import { CircleConfig, CircleData } from '../../../../models/internal_api/circleInterfaces.model';
import { DataCardCircleProps, CardMetric, CardType } from '../../../../models/internal_api/cardInterfaces.model';
import DataCircle from '../../DataCircle/DataCircle';
import './DataCardCircle.scss';
import { Metric, Metrics } from '../../../../models/internal_api/metricInterfaces.model';

import { useTranslation } from "react-i18next";

const singleCircleValue = (cardMetrics: CardMetric[]): number => {
    return cardMetrics.flatMap((cardMetric: CardMetric): number => cardMetric.value).reduce((prevValue: number, currentValue: number) => prevValue + currentValue);
}

export default function DataCardCircle(props: DataCardCircleProps) {
    //TRANSLATION INIT
    const { t } = useTranslation();

    const circleElement = () => {
        if (props.type !== CardType.MULTIPLE) {
            const circleData: CircleData = { size: '144px', color: props.config?.circleColor, value: singleCircleValue(props.metrics), text: t("events") };
            const circleConfig: CircleConfig = { circleData: circleData, filled: false, headerStyle: { color: props.config?.textColor, fontSize: '38px' }, textStyle: { color: '#252733', fontSize: '18px' } };
            return (
                <div className='DataCard__circle--single'>
                    <DataCircle {...circleConfig} />
                </div>
            )
        }
        else {
            const circles = props.metrics.map((metric: CardMetric) => {
                const metricColor: string = Metrics.filter((metricElement: Metric) => metricElement.name === metric.name)[0].color;
                const circleData: CircleData = { size: '108px', color: metricColor, value: metric.value, text: t("events") };
                const circleConfig: CircleConfig = { circleData: circleData, filled: false, headerStyle: { color: `rgba(${metricColor}, 1)`, fontSize: '28px' }, textStyle: { color: '#252733', fontSize: '18px' } };
                return (<DataCircle {...circleConfig} key={metric.value + metric.name} />);
            })

            return (
                <div className='DataCard__circle--multiple'>
                    {circles}
                </div>
            )
        }
    };

    return (
        <div className='DataCard__circle'>
            {circleElement()}
        </div>
    );
}
